import React, { Component } from 'react';
import { navigate } from '@reach/router'
import CreateAdminUser from '../presentation/create-admin-user';

export default class CreateAdminUserWidget extends Component {

    state = {
        firstName           : null,
        lastName            : null,
        email               : null,
        confirmUser         : null,
        phoneNumber         : null,
        showErrorModal      : false,
        errorMessage        : null
    };

    updateFormState = e => {
        let obj = {};
        if(e.target.name === 'confirmUser') {
            obj[e.target.name] = e.target.checked;
        } else {
            obj[e.target.name] = e.target.value;
        }
        this.setState(obj);
    };

    closeModal = () => {
        if( this.state.errorMessage )
            this.setState({errorMessage: null});
        else {
            this.setState({showModal: false});
            navigate(`/`)
        }
    };

    openModal = () => {
        this.setState({ showModal: true });
    };

    userFormValidations = () => {
        const { firstName, lastName, email, confirmUser } = this.state;
        let error = null;
        let errorField = null;

        if ( !firstName ) {
            errorField = 'firstName';
            error = "First name is a required field.";
        } else if ( !lastName ) {
            errorField = 'lastName';
            error = "Last name is a required field.";
        } else if (!email) {
            errorField = 'email';
            error = "Email is a required field.";
        } else if(!email.toLowerCase().endsWith('@bluedot.io') && !email.toLowerCase().endsWith('@rezolve.com')) {
            errorField = 'email';
            error = "Only @bluedot.io or @rezolve.com emails can be used to create a Superadmin user.";
        } else if(!confirmUser) {
            errorField = 'confirmUser';
            error = "Please tick the box to confirm a Bluedotconnect user is being created.";
        }

        if( error ) {
            this.setState({errorMessage: error, errorField: errorField});
            return false;
        }

        return true;
    };

    handleCreateAdminUser = () => {
        const { email, firstName, lastName } = this.state
        const createdBy = localStorage.getItem('userId')
        const user = { email, firstName, lastName, createdBy }

        if(this.userFormValidations()) {
            fetch('/service/adminUser', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('idToken')}`
                },
                credentials: 'same-origin',
                body: JSON.stringify(user)
            }).then(response => {
                if (response.status === 204) {
                    this.openModal()
                } else {
                    response.json().then(error => alert(error.errorMessage))
                }
            }).catch(console.log)
        }
    };

    render() {
        return (
            <CreateAdminUser 
                onCreateAdminUser={this.handleCreateAdminUser} 
                updateFormState={this.updateFormState} 
                showModal={this.state.showModal} 
                closeModal={this.closeModal} 
                errorMessage={this.state.errorMessage}
                error={this.state.errorMessage}
                errorField={this.state.errorField}
            />
        )
    }
}